<script setup>
const props = defineProps(["organisers"]);
</script>

<template>
  <div
    v-if="organisers"
    class="grid gap-8 grid-cols-3 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 md:gap-10 mb-12 md:mb-24"
  >
    <div
      v-for="logo in organisers"
      class="max-w-[200px] flex items-center justify-center h-20"
    >
      <img :src="logo.mediaItemUrl" class="w-full h-full object-contain" />
    </div>
  </div>
</template>
